import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeToSpotify}
            sections={<PairSyncGuideContent sourceKey="youtube" destKey="spotify" />}
        />
    );
}
